import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DatePickerMonth, DownloadFile, PrintFile, TableLoader } from '@livable/saas-react-components';
import { Typography, Grid } from '@mui/material';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { v4 as uuid } from 'uuid';
// import ExportStatementsModal from 'src/components/shared/ExportStatementsModal';
// import PrintStatementsModal from 'src/components/shared/PrintStatementsModal';
// import { StatementsBlock } from 'src/components/shared/StatementBlock';
import ResendStatementModal from '../ResendStatementModal';
import VoidStatementModal from '../VoidStatementModal';
import { canVoidStatement } from '../VoidStatementModal/canVoidStatement';
import emptyContactsImg from 'src/img/no-data.svg';
import { isLivableStaffFromToken } from 'src/utils/isLivableStaffFromToken';
import { useStore } from 'src/stores';
import { StatementsBlock } from '../StatementsBlock';
import useStyles from './styles';
import { TRANSACTION_TYPESV2 } from 'src/constants/payments';
export const Statements = observer(props => {
  const store = useStore();
  const classes = useStyles();
  const triggerRefresh = store.residencies.triggerRefresh;
  const accountId = props.accountId,
    predefinedData = props.predefinedData,
    propertyId = props.propertyId,
    residencyId = props.residencyId,
    userProfileData = props.userProfileData;
  const currentYear = predefinedData ? predefinedData.year ? moment(predefinedData.year).year() : moment(store.properties.serverBusinessDateOnly).year() : moment(store.properties.serverBusinessDateOnly).year();
  const currentMonth = predefinedData ? predefinedData.month ? moment(predefinedData.month).month() : moment(store.properties.serverBusinessDateOnly).month() : moment(store.properties.serverBusinessDateOnly).month();
  const initialDate = predefinedData ? new Date(currentYear, currentMonth) : new Date(moment(store.properties.serverBusinessDateOnly).subtract(1, 'months').endOf('month').toDate());
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    resendStatementId = _useState4[0],
    setResendStatementId = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    resendStatementFileId = _useState6[0],
    setResendStatementFileId = _useState6[1];
  const atLeastOne = store.payment.getDelayedCharges.charges.length || store.payment.getOtherCharges.charges.length || store.payment.getStatementCharges.charges.length || store.payment.getStatementCredits.charges.length || store.payment.getUtilityCharges.charges.length;
  const loading = isLoading || store.allocations.getAllocationTableInfoAsync.inProgress || store.payment.getResidentStatementByAccountAsync.inProgress;
  const charges = ['getStatementCharges', 'getStatementCredits'];

  // const chargesTypes = {
  //   utilityCharges: 'utilityCharges',
  //   delayedCharges: 'delayedCharges',
  //   otherCharges: 'otherCharges',
  // };

  const _useState7 = useState(initialDate),
    _useState8 = _slicedToArray(_useState7, 2),
    pickerDate = _useState8[0],
    setPickerDate = _useState8[1];
  const fetchData = async () => {
    setIsLoading(true);
    try {
      var _store$payment$reside, _store$payment$reside2, _store$payment$reside3, _store$payment$reside4, _store$payment$reside5, _store$payment$reside6, _store$payment$reside7;
      const resp = await store.payment.getResidentStatementByAccountAsync.run({
        year: moment(pickerDate).year(),
        month: moment(pickerDate).month(),
        accountId
      });
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        var _resp$response, _resp$response2;
        setResendStatementId(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.id);
        setResendStatementFileId(resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.paperFileId);
      }
      const billingCycleIds = [];
      const utilityIDS = new Set();
      const voidedTransactionIds = [];
      (_store$payment$reside = store.payment.residentStatements.utilityCharges.charges) === null || _store$payment$reside === void 0 || _store$payment$reside.map(i => {
        utilityIDS.add(i.utilityId);
        billingCycleIds.push(i.billingCycleId);
      });
      (_store$payment$reside2 = store.payment.residentStatements.delayedCharges.charges) === null || _store$payment$reside2 === void 0 || _store$payment$reside2.map(i => {
        utilityIDS.add(i.utilityId);
        billingCycleIds.push(i.billingCycleId);
      });
      (_store$payment$reside3 = store.payment.residentStatements.otherCharges.charges) === null || _store$payment$reside3 === void 0 || _store$payment$reside3.map(i => {
        utilityIDS.add(i.utilityId);
        billingCycleIds.push(i.billingCycleId);
      });
      (_store$payment$reside4 = store.payment.residentStatements.statementCharges.charges) === null || _store$payment$reside4 === void 0 || _store$payment$reside4.map(i => {
        utilityIDS.add(i.utilityId);
        billingCycleIds.push(i.billingCycleId);
        if (i.type === TRANSACTION_TYPESV2.Void) {
          var _i$metadata;
          voidedTransactionIds.push(i === null || i === void 0 || (_i$metadata = i.metadata) === null || _i$metadata === void 0 ? void 0 : _i$metadata.voidedTransactionId);
        }
      });
      (_store$payment$reside5 = store.payment.residentStatements.statementCredits.charges) === null || _store$payment$reside5 === void 0 || _store$payment$reside5.map(i => {
        utilityIDS.add(i.utilityId);
        billingCycleIds.push(i.billingCycleId);
        if (i.type === TRANSACTION_TYPESV2.Void) {
          var _i$metadata2;
          voidedTransactionIds.push(i === null || i === void 0 || (_i$metadata2 = i.metadata) === null || _i$metadata2 === void 0 ? void 0 : _i$metadata2.voidedTransactionId);
        }
      });
      const getTransactionHistoryV2ListingAsyncResp = await store.payment.getTransactionHistoryV2ListingAsync.run({
        transactionIds: voidedTransactionIds.filter(i => !!i)
      });
      await store.payment.setVoidedAdditionalInfo(getTransactionHistoryV2ListingAsyncResp);
      (_store$payment$reside6 = store.payment.residentStatements.statementCharges.charges) === null || _store$payment$reside6 === void 0 || _store$payment$reside6.map(i => {
        if (i.type === TRANSACTION_TYPESV2.Void) {
          utilityIDS.add(i === null || i === void 0 ? void 0 : i.relatedTransactionData.utilityId);
        }
      });
      (_store$payment$reside7 = store.payment.residentStatements.statementCredits.charges) === null || _store$payment$reside7 === void 0 || _store$payment$reside7.map(i => {
        if (i.type === TRANSACTION_TYPESV2.Void) {
          utilityIDS.add(i === null || i === void 0 ? void 0 : i.relatedTransactionData.utilityId);
        }
      });
      let utilityInfo;
      if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
        utilityInfo = await store.utilityProviders.getUtilityInfoAsync.run({
          utilityIds: [...Array.from(utilityIDS).filter(i => typeof i === 'string' && i.length)]
        });
      } else {
        utilityInfo = await store.utilityProviders.getPropertyUtilityInfoAsync.run({
          utilityIds: [...Array.from(utilityIDS).filter(i => typeof i === 'string' && i.length)],
          propertyId: propertyId
        });
      }
      await store.payment.setUtilityInfo(utilityInfo);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    try {
      fetchData();
    } catch (e) {
      console.log('useEffect Error', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickerDate, triggerRefresh]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.topActionDatepicker
  }, /*#__PURE__*/React.createElement(DatePickerMonth, {
    date: pickerDate,
    setDate: setPickerDate
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, store.account.featureFlagsStore.isFinalStatementEstimationEnabled && canVoidStatement({
    disableVoidStatement: store.company.companyFeatureStore.disableVoidStatement,
    isFinalStatement: store.payment.isFinalStatement,
    // From the token: the store's staff view is on `store.account.userProfile`, not on `store.account`.
    isLivableStaff: isLivableStaffFromToken()
  }) ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: true
  }, /*#__PURE__*/React.createElement(VoidStatementModal, {
    disabled: store.payment.isVoided || !atLeastOne || loading
  })) : null, localStorage.getItem('livable_demo_mode') !== 'Demo' && !(!store.payment.getUtilityCharges.charges.length && !store.payment.getOtherCharges.charges.length && !store.payment.getDelayedCharges.charges.length && !store.payment.getStatementCharges.charges.length && !store.payment.getStatementCredits.charges.length) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: true
  }, /*#__PURE__*/React.createElement(ResendStatementModal, {
    residencyId: residencyId,
    userProfileData: userProfileData,
    resendStatementId: resendStatementId,
    resendStatementFileId: resendStatementFileId
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: true
  }, /*#__PURE__*/React.createElement(PrintFile, {
    disabled: !store.payment.residentStatements.fileId || store.files.getPresignedFileDownloadUrlAsync.inProgress,
    fileId: store.payment.residentStatements.fileId,
    getUrlAsyncCallback: async () => {
      const resp = await store.files.getPresignedFileDownloadUrlAsync.run({
        fileId: store.payment.residentStatements.fileId,
        isPreview: true
      });
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        return resp.response;
      }
    },
    href: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled ? null : "".concat(store.files.getFilePreviewLink({
      fileId: store.payment.residentStatements.fileId
    })),
    text: "general.print",
    variant: "action"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: true
  }, /*#__PURE__*/React.createElement(DownloadFile, {
    disabled: !store.payment.residentStatements.fileId,
    fileId: store.payment.residentStatements.fileId,
    usePreSignedDownload: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled,
    store: store,
    variant: "action"
  }))))), loading ? /*#__PURE__*/React.createElement(TableLoader, null) : null, charges.map(charge => {
    const statement = toJS(store.payment[charge]);
    if (statement.charges.length) return /*#__PURE__*/React.createElement(StatementsBlock, {
      charges: [...statement.charges.map(i => i)],
      hideNotes: true,
      hidePostAction: true,
      isFinalStatement: store.payment.isFinalStatement,
      key: uuid(),
      statement: {
        statement
      },
      statementPropertyId: store.payment.residentStatements.propertyId,
      subTitle: statement.subTitle,
      title: statement.title,
      total: statement.total
    });
  }), atLeastOne ? /*#__PURE__*/React.createElement("div", {
    className: classes.totalSummaryWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: isMobileOnly ? 'h4' : 'h3',
    color: "light"
  }, "Total statement:"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.total
  }, "$", Number(store.payment.residentStatements.total).toFixed(2))) : !loading && /*#__PURE__*/React.createElement("div", {
    className: classes.emptyState
  }, /*#__PURE__*/React.createElement("img", {
    src: emptyContactsImg,
    width: "160",
    height: "160",
    alt: "empty contacts image"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light"
  }, "No statements")));
});